import {isCountryInNorthAmerica} from '../CountryRestriction/CountryRestrictionUtility';

export class NavigationShopController {
  private shopUrl = 'https://shop.faulhaber.com';
  private customerData: {
    customer: {fullname?: string, firstname?: string, websiteId?: string, data_id: number},
    cart: { summary_count: number, items: Array<any> },
  }|null = null;

  constructor() {
    this.initLoginButton();
    if (this.isCountryPermitted()) {
      this.fetchFromShop();
    }
  }

  isCountryPermitted(): boolean {
    return isCountryInNorthAmerica();
  }

  isCustomerLoggedIn(): boolean {
    if (this.customerData && 'customer' in this.customerData && 'fullname' in this.customerData.customer) {
      return true;
    }
    return false;
  }

  numberOfItemsInCart(): number {
    if (this.customerData && 'cart' in this.customerData && 'summary_count' in this.customerData.cart) {
      return this.customerData.cart.summary_count;
    }
    return 0;
  }

  prepareCart() {
    const cartCount: HTMLDivElement|null = document.querySelector('.js-cartCount');
    if (cartCount && this.numberOfItemsInCart() > 0) {
      cartCount.innerHTML = this.numberOfItemsInCart() + '';
    }
  }

  prepareMyAccount() {
    const headerMyAccButton: NodeListOf<HTMLLinkElement> = document.querySelectorAll('.js-shopMyAccButton');
    const headerLoginButton: NodeListOf<HTMLLinkElement> = document.querySelectorAll('.js-shopLoginButton');
    const headerLogoutButton: NodeListOf<HTMLLinkElement> = document.querySelectorAll('.js-shopLogoutButton');

    if (this.isCustomerLoggedIn()) {
      headerMyAccButton.forEach((button) => {
        button.classList.remove('hide');
      });
      headerLogoutButton.forEach((button) => {
        button.classList.remove('hide');
      });
      headerLoginButton.forEach((button) => {
        button.classList.add('hide');
      });
    }
  }

  fetchFromShop() {
    const url = `${this.shopUrl}/customer/section/load/?sections=customer,cart`;
    fetch(url, {credentials: 'include', mode: 'cors'})
      .then((response) => response.json())
      .then((json) => this.customerData = json)
      .catch((reason => console.error(reason)))
      .finally(() => {
        this.prepareCart();
        this.prepareMyAccount();
      })
    ;
  }

  initLoginButton() {
    const loginButton: HTMLButtonElement|null = document.querySelector('.js-loginDropdownButton');
    const loginDropdown: NodeListOf<HTMLDivElement> = document.querySelectorAll('.js-loginDropdown');
    loginButton?.addEventListener('click', () => {
      loginButton?.classList.toggle('button--outline');
      loginDropdown.forEach((dropdownElem) => {
        dropdownElem.classList.toggle('hide');
      });
    });
    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.js-loginButtonWrap')) {
        loginButton?.classList.add('button--outline');
        loginDropdown.forEach((dropdownElem) => {
          dropdownElem.classList.add('hide');
        });
      }
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 1200) {
        loginButton?.classList.add('button--outline');
        loginDropdown.forEach((dropdownElem) => {
          dropdownElem.classList.add('hide');
        });
      }
    });
  }
}
